import React, { useState } from 'react';
import { AdvancedMarker, AdvancedMarkerProps } from '@vis.gl/react-google-maps';
import { MapPin } from '../../MapPin';
import { IconRestaurant } from '@justeattakeaway/pie-icons-react';
import { IUser } from '@src/shared/context/current-user';
import { globalStyles } from 'snacks-design-system';
import MapCard from '../../MapCard';
import PIEText from '@src/shared/components/PIEText';

interface RestaurantMapMarkerProps {
  restaurantInfo?: IUser;
  onClick?: () => void;
}

const { xdsColorContentLinkDistinct, xdsColorContentLight } = globalStyles;

export const RestaurantMapMarker = ({
  restaurantInfo,
  position,
  onClick,
}: AdvancedMarkerProps & RestaurantMapMarkerProps) => {
  const [pinClickToggle, setPinClickToggle] = useState(false);
  return (
    <>
      {pinClickToggle && (
        <AdvancedMarker position={position}>
          <MapCard>
            <PIEText
              size="var(--xds-font-size-14)"
              align="left"
              text={restaurantInfo?.name}
              fontWeight="var(--xds-font-weight-bold)"
            />
          </MapCard>
        </AdvancedMarker>
      )}
      <AdvancedMarker
        onClick={() => {
          onClick && onClick();
          setPinClickToggle(!pinClickToggle);
        }}
        position={position}
      >
        <MapPin
          pinBackgroundColor={xdsColorContentLinkDistinct}
          bottomDotBackgroundColor={xdsColorContentLight}
          bottomDotStrokeColor={xdsColorContentLinkDistinct}
        >
          <IconRestaurant color={xdsColorContentLight} size="m" />
        </MapPin>
      </AdvancedMarker>
    </>
  );
};

export default RestaurantMapMarker;
